<template>
  <div id="section10" class="page-section10" :style="bgStyle">
    <!-- <img src="/img/Wayang-logo.png" alt="Gapura" class="s10-bg-gapura">
    <div class="s10-wayang">
      <img src="/img/Wayang-logo.png" alt="Wayang Pria">
      <img src="/img/Wayang-logo.png" alt="Wayang Wanita" style="transform: scaleX(-1);">
    </div> -->

    <div class="s10-content fade-on-scroll">
      <div class="s10-photo-oval">
        <img :src="couplePhotoUrl" alt="Couple" loading="lazy">
      </div>
      <p class="s10-text">Merupakan suatu kebahagiaan bagi kami apabila<br>Bapak/Ibu/Saudara/i berkenan untuk hadir dan memberikan<br>doa restu.</p>
      <p class="s10-text-closing">Kami yang berbahagia</p>
      <h2 class="s10-title">{{ orderedCoupleNames }}</h2>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useInvitationStore } from '@/store';

export default {
  name: 'FooterSection',
  computed: {
    ...mapState(useInvitationStore, ['client']),
    bgStyle() {
      return { backgroundImage: `url('/img/cover1.jpeg')` };
    },
    orderedCoupleNames() {
      if (!this.client.nama_pria && !this.client.nama_wanita) return 'Pria & Wanita';
      return this.client.hajat === 'wanita'
        ? `${this.client.nama_wanita} & ${this.client.nama_pria}`
        : `${this.client.nama_pria} & ${this.client.nama_wanita}`;
    },
    couplePhotoUrl() {
      const foto = this.client.foto_couple || this.client.foto_cover;
      return foto
        ? `https://admin.itsyourdayofficial.com/foto_cover/${foto}`
        : 'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=600&q=80';
    },
  },
  mounted() {
    this.setupFadeObserver();
  },
  beforeUnmount() {
    if (this._fadeObserver) this._fadeObserver.disconnect();
  },
  methods: {
    setupFadeObserver() {
      if (typeof IntersectionObserver === 'undefined') return;
      const observer = new IntersectionObserver(
        (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('is-visible'); }),
        { threshold: 0.15 }
      );
      this.$el.querySelectorAll('.fade-on-scroll').forEach(el => observer.observe(el));
      this._fadeObserver = observer;
    },
  },
};
</script>

<style scoped>
.fade-on-scroll { opacity: 0; transform: translateY(40px); transition: opacity 1s ease-out, transform 1s ease-out; }
.fade-on-scroll.is-visible { opacity: 1; transform: translateY(0); }

.page-section10 {
  background-size: cover; background-position: bottom center;
  padding: 6rem 2rem 2rem; position: relative; overflow: hidden;
  display: flex; flex-direction: column; align-items: center; justify-content: flex-start; min-height: 85vh;
}
.page-section10::before { content: ''; position: absolute; inset: 0; background: rgb(255 255 255 / 60%); z-index: 0; }
.s10-content { position: relative; z-index: 10; display: flex; flex-direction: column; align-items: center; text-align: center; width: 100%; }
.s10-photo-oval { width: 200px; height: 300px; border-radius: 120px; overflow: hidden; margin-bottom: 2rem; border: 3px solid rgba(74,92,116,0.4); box-shadow: 0 10px 25px rgba(28,45,74,0.3); z-index: 10; }
.s10-photo-oval img { width: 100%; height: 100%; object-fit: cover; }
.s10-wayang { position: absolute; bottom: -2rem; left: 0; width: 100%; display: flex; justify-content: space-between; pointer-events: none; z-index: 2; }
.s10-wayang img { height: 400px; width: auto; opacity: 0.9; }
.s10-bg-gapura { position: absolute; bottom: -5%; left: 50%; transform: translateX(-50%); width: 80%; max-width: 500px; height: auto; z-index: 1; opacity: 0.8; }
.s10-text { font-family: 'Cormorant Garamond', serif; font-size: 1.15rem; color: #000; max-width: 400px; line-height: 1.6; font-weight: 600; margin-bottom: 2rem; z-index: 10; position: relative; }
.s10-text-closing { font-family: 'Cormorant Garamond', serif; font-size: 1.15rem; color: #000; font-weight: 600; margin-bottom: 1rem; z-index: 10; position: relative; }
.s10-title { font-family: 'Great Vibes', cursive; font-size: 4.5rem; color: #1C2D4A; font-weight: 500; margin-bottom: 4rem; z-index: 10; position: relative; }

@media (max-width: 480px) {
  .s10-title { font-size: 3.2rem; margin-bottom: 2rem; }
}
</style>
